var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.releaseTitle)?_c('div',{attrs:{"id":"release_info"}},[_vm._v(_vm._s(_vm.releaseTitle))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }